import { Typography } from 'antd';
import styled from 'styled-components';

import { StyleConstantsEnum } from '@style/style.constants';

import { TextProps } from '@atom/typography/typography';
import { TitleSizes } from '@atom/typography/typography.options';
import { ColorEnum } from '@enum/style/color.enum';
import { isExist } from '@util/data/is-exist';

export interface StyledTitleProps {
  color?: ColorEnum;
  weight?: number;
  mt?: number;
  mb?: number;
  letterSpacing?: number;
}

export const StyledTitle = styled(Typography.Title)<StyledTitleProps>`
  font-family: ${StyleConstantsEnum.TitleFontFamily};
  letter-spacing: ${(props) => (props.letterSpacing ? `${props.letterSpacing}px` : 'inherit')};

  &.ant-typography {
    margin-top: ${(props) => props.mt ?? 0}px !important;
    font-weight: ${(props) => props.weight ?? props.theme.fontWeightStrong};
    color: ${(props) => props.color};
    margin-bottom: ${(props) => props.mb ?? 0}px;
  }
`;

export const StyledSmallTitle = styled.h6<StyledTitleProps>`
  font-family: ${StyleConstantsEnum.TitleFontFamily};
  margin-top: ${(props) => props.mt ?? 0}px !important;
  font-weight: ${(props) => props.weight ?? props.theme.fontWeightStrong};
  color: ${(props) => props.color};
  margin-bottom: ${(props) => props.mb ?? 0}px;
  letter-spacing: ${(props) => (props.letterSpacing ? `${props.letterSpacing}px` : 'inherit')};
  font-size: 16px;
  line-height: 20px;
`;

export const StyledText = styled(Typography.Text)<TextProps>`
  line-height: ${(props) => TitleSizes[props.level ?? 'm'] + 4}px;
  font-size: ${(props) => TitleSizes[props.level ?? 'm']}px;
  font-weight: ${(props) => props.weight ?? 'normal'};
  color: ${(props) => props.color};
  letter-spacing: ${(props) => (props.letterSpacing ? `${props.letterSpacing}px` : 'inherit')};
`;

export const StyledParagraph = styled(Typography.Paragraph)<TextProps>`
  line-height: ${(props) => TitleSizes[props.level ?? 'm'] + 4}px;
  font-size: ${(props) => TitleSizes[props.level ?? 'm']}px;
  font-weight: ${(props) => props.weight ?? 'normal'};
  color: ${(props) => props.color};
  ${(props) => (isExist(props.mb) ? `margin-bottom: ${props.mb}px !important;` : '')}
  letter-spacing: ${(props) => (props.letterSpacing ? `${props.letterSpacing}px` : 'inherit')};
`;
